const NotFound = () => {
    return (
        <>

            <div className="content_section list_title">
                <div className="content_group _404">
                    <h1 className="h_center_title _404">הדף לא נמצא.
                        <br></br>
                        הדף שאתה מחפש אינו קיים או הועבר.

                    </h1>
                </div>
                <div className="txt_404">- 404 -</div>
            </div>
        </>
    )
};

export default NotFound;